<template>
  <div style="min-height: 750px">
    <div class="classBnaer">
      <div class="classHead">
        <div class="leftBox">温馨提示：学员可在此查看和打印发票</div>

        <!-- <div>
          <el-input
            size="small"
            style="width: 205px; margin-right: 5px"
            placeholder="请输入订单编号"
            v-model="queryParams.orderNo"
            :clearable="true"
          ></el-input>
          <el-input
            size="small"
            style="width: 145px; margin-right: 5px"
            placeholder="请输入班级名称"
            v-model="queryParams.className"
            :clearable="true"
          ></el-input>
          <el-select
            size="small"
            style="width: 145px; margin-right: 5px"
            placeholder="请选择订单状态"
            v-model="queryParams.orderStatus"
            :clearable="true"
          >
            <el-option label="未支付" value="01"> </el-option>
            <el-option label="已支付" value="20"> </el-option>
            <el-option label="已取消" value="00"> </el-option>
          </el-select>

          <el-button icon="el-icon-search" size="small" type="primary" @click="searOrder"> 搜索 </el-button>
        </div> -->
      </div>

      <div class="list">
        <el-table :data="orderList.orderList" style="width: 100%">
          <el-table-column prop="ordNo" label="订单编号" width="180" align="center"> </el-table-column>
          <el-table-column prop="ordPayTime" label="时间" width="180" align="center"> </el-table-column>
          <el-table-column prop="trainProjectName" label="项目名称" align="center"> </el-table-column>
          <el-table-column prop="invoiceStatus" label="生成发票" align="center">
            <template slot-scope="scope">
              <span style="color: #4077c0">{{
                scope.row.invoiceStatus == '07'
                  ? '开具中'
                  : scope.row.invoiceStatus == '08'
                  ? '已上传'
                  : scope.row.invoiceStatus == '09'
                  ? '申请失败'
                  : ''
              }}</span>
            </template>
          </el-table-column>
         
          <el-table-column prop="ORD_STATUS" label="支付状态" align="center">
            <template slot-scope="scope">
              <span style="color: #4077c0" v-if="scope.row.ordStatus == '01' || scope.row.ordStatus == '02'">
                <div style="text-align: center">未支付</div>
                <div v-if="countdownMap[scope.row.id] !== undefined && countdownMap[scope.row.id] > 0">
                  {{ formatCountdown(scope.row.id) }}
                </div>
              </span>
              <span style="color: #4077c0" v-else>
                {{
                  scope.row.ordStatus == '20'
                    ? '已支付'
                    : scope.row.ordStatus == '00'
                    ? '已取消'
                    : scope.row.ordStatus == '10' || scope.row.ordStatus == '11' || scope.row.ordStatus == '12'
                    ? ''
                    : '未支付'
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" align="center">
            <template slot-scope="scope">
              <!-- <div
                class="btn"
                @click="invoice(scope.row)"
                v-if="
                  scope.row.ordStatus == '20' &&
                  (scope.row.invoiceStatus == '' || scope.row.invoiceStatus == null) &&
                  scope.row.ordMoneySum != '0'
                "
              >
                申请开票
              </div> -->
              <div>
                <div>
                  <div v-if="scope.row.invoiceStatus == '07'">开票中</div>
                  <div v-if="scope.row.invoiceStatus == '08'" style="color: rgb(64, 119, 192); cursor: pointer" @click="downFp(scope.row)">
                    查看发票
                  </div>
                </div>
              </div>
              <div
                class="btn"
                style="color: #b93b3b; border: 1px solid #b93b3b"
                @click="payment(scope.row)"
                v-if="scope.row.ordStatus == '01'"
              >
                支付
              </div>
              <div style="display: flex; justify-content: center">
                <div v-if="scope.row.ordStatus == '01'" style="cursor: pointer" @click="quOrder(scope.row)">取消</div>

                <!-- <div v-if="scope.row.ORD_STATUS == '00'" style="color: #b93b3b; cursor: pointer" @click="deletOrder(scope.row)">删除</div> -->
                <div style="margin-left: 5px; cursor: pointer" @click="showDetil(scope.row)" v-if="scope.row.ordStatus != '00'">详情</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 订单详情 -->
    <el-dialog title="订单详情" :visible.sync="dialogVisible" width="50%">
      <div class="check_box" style="display: flex">
        <div style="width: 100%">
          <table class="table1">
            <tbody>
              <tr>
                <td width="30%" class="td1">订单号</td>
                <td width="60%" id="eordNo" class="td2">{{ orderOutList.ordNo }}</td>
              </tr>
              <!-- <tr>
                <td class="td1">订单金额</td>
                <td id="ordTotalMoney" class="td2">￥{{ orderOutList.ordTotalMoney }}</td>
              </tr> -->
              <!-- <tr>
                <td class="td1">支付金额</td>
                <td id="ordMoneysum" class="td2" v-if="orderOutList.ordType !== '03'">￥{{ orderOutList.ordMoneysum }}</td>
                <td id="ordMoneysum" class="td2" v-else>￥{{ orderOutList.ordTotalMoney }}</td>
              </tr> -->
              <tr>
                <td class="td1">支付方式</td>
                <td id="ordPaytype" class="td2">
                  {{
                    orderOutList.ordPayType == '01'
                      ? '未到账'
                      : orderOutList.ordPayType == '02'
                      ? 'pc支付宝支付'
                      : orderOutList.ordPayType == '03'
                      ? '移动端支付宝支付'
                      : orderOutList.ordPayType == '04'
                      ? 'pc微信支付'
                      : orderOutList.ordPayType == '05'
                      ? '移动端微信支付'
                      : orderOutList.ordPayType == '06'
                      ? '银行汇款'
                      : orderOutList.ordPayType == '07'
                      ? '手工'
                      : orderOutList.ordPayType == '08'
                      ? '小程序'
                      : orderOutList.ordPayType == '09'
                      ? '学习卡'
                      : ''
                  }}
                </td>
              </tr>
              <tr>
                <td class="td1">支付时间</td>
                <td id="ordPaytime" class="td2">{{ orderOutList.ordPayTime }}</td>
              </tr>
              <!-- <tr>
                <td class="td1">支付渠道</td>
                <td id="ordPaySource" class="td2">
                  {{
                    orderOutList.ordPaySource == '01'
                      ? '电脑web'
                      : orderOutList.ordPaySource == '02'
                      ? '手机网站'
                      : orderOutList.ordPaySource == '03'
                      ? '手机app'
                      : orderOutList.ordPaySource == '04'
                      ? '公众号'
                      : ''
                  }}
                </td>
              </tr> -->

              <tr>
                <td class="td1">订单状态</td>
                <td id="ordStatus" class="td2">
                  {{
                    orderOutList.ordStatus == '01'
                      ? '未支付'
                      : orderOutList.ordStatus == '20'
                      ? '已支付'
                      : orderOutList.ordStatus == '10'
                      ? '全部退'
                      : orderOutList.ordStatus == '11'
                      ? '部分退'
                      : orderOutList.ordStatus == '12'
                      ? '申请退款'
                      : orderOutList.ordStatus == '00'
                      ? '已取消'
                      : ''
                  }}
                </td>
              </tr>
              <tr>
                <td class="td1">订单类型</td>
                <td id="ordType" class="td2">
                  {{ orderOutList.ordType == '01' ? '个人订单' : orderOutList.ordType == '02' ? '机构订单' : '' }}
                </td>
              </tr>
              <!-- <tr>
                <td class="td1">生成发票</td>
                <td id="invoiceClainType" class="td2">
                  {{ orderOutList.invoiceClainType == '01' ? '错' :orderOutList.invoiceClainType == '02'? '对' :''}}
                </td>
              </tr> -->
              <!-- <tr>
                <td class="td1">发票批次</td>
                <td id="fppc" class="td2">
                  <span v-if="orderOutList.invoiceBatch !== null">
                    {{ orderOutList.invoiceBatch }}
                  </span>
                </td>
              </tr> -->
            </tbody>
          </table>
        </div>
        <!-- <div style="width: 49%">
          <table class="table2" id="classDetail" style="margin-left: 20px">
            <tbody>
              <tr style="height: 50px; background: #f7f7f7">
                <td width="33%" style="text-align: center">报名班级</td>
                <td width="33%" style="text-align: center; padding: 0">课程/考试/练习</td>
              </tr>

              <tr class="tr_name" v-for="(orderOutList, index) in eOrderDetailList" :key="index" height="50">
                <td>{{ orderOutList.className }}</td>
                <td>{{ orderOutList.courseName ? orderOutList.courseName : orderOutList.quizName }}</td>
              </tr>
            </tbody>
          </table>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 开票 -->
    <el-dialog :visible.sync="invoiceShow" width="500px">
      <div style="border: 0; width: 100%; margin: 0 auto" align="center">
        <div style="display: flex">
          <div style="line-height: 40px; font-size: 16px; color: #2878ff">发票抬头</div>
          <el-input style="margin-left: 41px; width: 350px" type="text" v-model="invoices.invoiceHeader" placeholder="请填写发票抬头" />
        </div>
        <div></div>
        <div style="display: flex; margin-top: 20px">
          <div style="line-height: 40px; font-size: 16px; color: #2878ff">纳税人识别号</div>
          <el-input
            style="margin-left: 10px; width: 350px"
            type="text"
            v-model="invoices.identifyNum"
            placeholder="请填写纳税人识别号或统一社会信用代码"
          />
        </div>
        <div style="padding-left: 0; text-align: center; margin-top: 20px; font-size: 14px; color: #999999; word-wrap: ">
          <div>
            填写要求请见<a style="color: #ff8000" target="_blank" href="http://www.chinatax.gov.cn/n810341/n810755/c2644618/content.html"
              >《国家税务总局关于增值税发票开具有关问题的公告》</a
            >
          </div>
        </div>
        <p style="padding-left: 0; text-align: center; margin-top: 5px; font-size: 14px; color: #999999">
          开具增值税普通发票，请于缴费当年领取，不支持跨年度领取
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceShow = false">取 消</el-button>
        <el-button type="primary" @click="submitInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

import { toOrderList, doCancelOrder, getOrderDetail, toGenerateInvoice, queryInvoiceResult } from '@/api/study.js';
import { toGenerateOrder } from '@/api/pay.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      dialogVisible: false, //订单详情
      invoiceShow: false, //申请开票
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      orderList: [], //订单列表
      independentExamList: [], //独立考试
      eOrderDetailList: [], //课程内容
      orderOutList: {}, //订单内容
      orderId: '', //申请开票id
      invoices: {
        invoiceHeader: '',
        identifyNum: ''
      },
      falg: true,
      timerId: null,
      totalSeconds: 0,
      timerIdMap: {},
      countdownMap: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 启动单个订单的倒计时
    startCountdownForOrder(orderId, surplusTimeMs) {
      if (this.timerIdMap[orderId]) {
        clearInterval(this.timerIdMap[orderId]);
      }
      // 转为秒
      let totalSeconds = Math.floor(surplusTimeMs / 1000);
      this.$set(this.countdownMap, orderId, totalSeconds);
      this.timerIdMap[orderId] = setInterval(() => {
        if (this.countdownMap[orderId] > 0) {
          this.$set(this.countdownMap, orderId, this.countdownMap[orderId] - 1);
        } else {
          clearInterval(this.timerIdMap[orderId]);
          delete this.timerIdMap[orderId];
          // 倒计时结束，5秒后刷新列表
          setTimeout(() => {
            this.toOrderList();
          }, 5000);
        }
      }, 1000);
    },

    // 停止所有倒计时
    stopAllCountdowns() {
      Object.values(this.timerIdMap).forEach(timerId => clearInterval(timerId));
      this.timerIdMap = {};
      this.countdownMap = {};
    },

    // 格式化显示倒计时
    formatCountdown(orderId) {
      const seconds = this.countdownMap[orderId] || 0;
      if (seconds <= 0) return '00:00:00';
      const h = Math.floor(seconds / 3600)
        .toString()
        .padStart(2, '0');
      const m = Math.floor((seconds % 3600) / 60)
        .toString()
        .padStart(2, '0');
      const s = (seconds % 60).toString().padStart(2, '0');
      return `${h}:${m}:${s}`;
    },

    //下载发票
    downloadPdf(url) {
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => {
        this.$message({
          type: 'success',
          message: '下载成功'
        });
      }, 1000);
    },
    //查看发票
    downFp(item) {
      // this.$alert('发票正在加载中，请稍等', '温馨提示', {
      //   confirmButtonText: '确定',
      //   callback: action => {}
      // });
        setTimeout(() => {
        this.$message({
          type: 'warning',
          message: '发票正在加载中，请稍等'
        });
      }, 1000);
      setTimeout(() => {
        queryInvoiceResult({ orderNo: item.ordNo }).then(res => {
          console.log(res);
          if (res.data.data.result && res.data.data.result != '' && res.data.data.result != null&& res.data.data.result != 'null') {
            // setTimeout(() => {
              this.downloadPdf(res.data.data.result);
            // }, 2000);
          } else if(res.data.data.result ==null||res.data.data.result =='null'){
            this.$message({
               type: 'warning',
              message: '发票正在开具中，请稍后再试。'
            });
          }
          else {
            this.$message({
              message: '下载失败'
            });
          }
        });
      }, 4000);
    },
    searOrder() {
      this.stopCountdown();
      toOrderList(this.queryParams).then(res => {
        this.orderList = res.data.data;
        this.orderList.orderList.forEach(item => {
          if (item.ordStatus === '01' && item.surplusTime) {
            const timeMs = Number(item.surplusTime);
            if (!isNaN(timeMs) && timeMs > 0) {
              // 使用 ordNo 作为 key（更安全）
              const key = item.ordNo || item.id;
              if (key) {
                this.startCountdownForOrder(key, timeMs);
              }
            }
          }
        });
      });
    },
    //支付
    payment(row) {
      console.log(row);

      this.$router.push({
        path: '/toPayOrder',
        query: {
          orderId: row.id
        }
      });
    },
    //取消
    quOrder(row) {
      this.$confirm('是否确认取消本条订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          doCancelOrder({ orderId: row.id }).then(res => {
            if (res.data.code == '200') {
              this.$message({
                type: 'success',
                message: '取消成功!'
              });
            }
            setTimeout(() => {
              this.toOrderList();
            }, 800);
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },

    showDetil(row) {
      getOrderDetail({ id: row.id }).then(res => {
        console.log(res.data.data);
        // this.independentExamList = res.data.data.independentExamList;
        // this.eOrderDetailList = res.data.data.eOrderDetailList;
        this.orderOutList = res.data.data;
      });
      this.dialogVisible = true;
    },
    invoice(row) {
      this.orderId = row.id;
      this.invoiceShow = true;
      this.falg = true;
      this.invoices.invoiceHeader = '';
      this.invoices.identifyNum = '';
    },
    //确定申请发票
    submitInfo() {
      if (this.invoices.invoiceHeader == '' || this.invoices.identifyNum == '') {
        this.$message.error('请输入发票信息');

        return false;
      }

      if (this.invoices.identifyNum.length == 18) {
        let ptn = /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}/;
        let ma = ptn.test(this.invoices.identifyNum);
        if (!ma) {
          this.$message.error('纳税人识别号不符合规则!');
          return;
        }
      } else if (this.invoices.identifyNum.length == 15) {
        let ptn = /^[0-9a-zA-Z]{15}$/;
        let ma = ptn.test(this.invoices.identifyNum);
        if (!ma) {
          this.$message.error('纳税人识别号不符合规则!');
          return;
        }
      } else if (this.invoices.identifyNum.length == 20) {
        let ptn = /^[0-9]{6}[0-9a-zA-Z]{9}[0-9]{5}$/;
        let ma = ptn.test(this.invoices.identifyNum);
        if (!ma) {
          this.$message.error('纳税人识别号不符合规则!');
          return;
        }
      } else {
        this.$message.error('纳税人识别号不符合规则!');
        return;
      }
      if (!this.falg) {
        return this.falg;
      }
      this.falg = false;
      let data = {
        invoiceHeader: this.invoices.invoiceHeader,
        identifyNum: this.invoices.identifyNum,
        orderId: this.orderId
      };
      toGenerateInvoice(data).then(res => {
        if (res.data.code == '200') {
          this.$message({
            message: res.data.msg,
            type: 'success'
          });
          this.invoiceShow = false;
          setTimeout(() => {
            this.toOrderList();
          }, 1000);
        }
      });
    },
    toOrderList() {
      toOrderList({}).then(res => {
        this.stopAllCountdowns();
        console.log(res);

        this.orderList = res.data.data;
        this.orderList.orderList.forEach(item => {
          if (item.ordStatus === '01' && item.surplusTime != null && !isNaN(item.surplusTime)) {
            this.startCountdownForOrder(item.id, Number(item.surplusTime));
          }
        });
      });
    },
    startCountdown() {
      this.timerId = setInterval(() => {
        --this.totalSeconds;
      }, 1000);
    },
    stopCountdown() {
      clearInterval(this.timerId);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.toOrderList();
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.check_box {
  max-height: 541px;
  //overflow-y: scroll;
  table {
    width: 100%;
    tr {
      height: 28px;
      td {
        height: 50px;
        border: 1px solid #eee;
        padding-left: 10px;
        font-size: 12px;
        color: #333333;
      }
    }
    .td1 {
      height: 50px;
      background: #f7f7f7;
      text-align: center;
      padding-left: 0;
    }
  }
}
.classBnaer {
  width: 1170px;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  .classHead {
    display: flex;
    justify-content: space-between;
    .leftBox {
      width: 280px;
      height: 36px;
      background: rgba(255, 128, 0, 0.1);
      border-radius: 6px;
      color: #ff8000;
      font-size: 14px;
      text-align: center;
      line-height: 36px;
    }
  }
  .list {
    margin-top: 15px;
    .btn {
      cursor: pointer;
      width: 70px;
      height: 30px;
      border: 1px solid #2878ff;
      border-radius: 4px;
      text-align: center;
      line-height: 30px;
      margin: 0 auto;
      color: #2878ff;
    }
  }
}
</style>
